import React from 'react'

import MenuSettingsControl from '../MenuSettingsControl'

export default () => [
  {
    renderer: () => <MenuSettingsControl />
  }
]
